export default __webpack_public_path__ + "creative_professionals.ff14ed15.png";